<template>
    <div>
        <spinner v-if="mismatched === null"></spinner>
        <table v-if="mismatched !== null">
            <thead>
                <tr>
                    <th>Variable</th>
                    <th>Level #</th>
                    <th>Year 1</th>
                    <th>Label 1</th>
                    <th>Year 2</th>
                    <th>Label 2</th>
                </tr>
            </thead>
            <tr v-for="m1 in mismatched" v-bind:key="m1.variable">
                <td>{{ m1.variable }}</td>
                <td>{{ m1.levelNumber }}</td>
                <td>{{ m1.firstYears }}</td>
                <td>{{ m1.label1 }}</td>
                <td>{{ m1.secondYears }}</td>
                <td>{{ m1.label2 }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import levelValidator from '@/scripts/levelValidator';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import commonApiHelper from '@/scripts/commonApiHelper';
import spinner from '@/components/sub/spinner';
import store from '@/store';
import $ from 'jquery';

export default {
    components: {
        spinner: spinner
    },
    data: function () {
        var vm = this;
        current.initializeValidateVariables('Validate Levels (Categories)');

        var vmData = {
            mismatched: null
        };
        loadLevelsFromApi(vmData);
        return vmData;
    },
    methods: {}
};

function loadLevelsFromApi(vmData) {
    let timeoutSeconds = 0; // No limit
    let parameters = [];
    commonApiHelper.addServiceParameters(parameters, 'brfss_p.api.sas');
    parameters.push({ queryCode: 'type', value: 'variablesAndCategories' });
    parameters.push({ queryCode: 'output_format', value: 'json' });
    let apiFormData = commonApiHelper.toQueryString(parameters);
    store.dispatch('display/setIsLoading', true);
    $.ajax({
        url: process.env.VUE_APP_SAS_BROKER,
        type: 'POST',
        timeout: timeoutSeconds * 1000,
        data: apiFormData,
        success: function (data) {
            // loadLevelsFromApi(vmData, data.variables);
            // let variables = data.variables;
            vmData.mismatched = levelValidator.getMismatchedCategories(
                data.variables,
                data.categories
            );
            store.dispatch('display/setIsLoading', false);
        },
        error: function (jqXHR) {
            console.log('API Error', jqXHR);
            store.dispatch('display/setIsLoading', false);
        }
    });
}
</script>

<style scoped>
td {
    padding: 5px 10px 5px 10px;
}

thead {
    font-weight: bold;
}
</style>
